import React, { useEffect } from "react";
import BlockedAccessPage from "../components/blockedAccess";
import Slider from "react-slick";
import { ReactComponent as ArrowLeft } from '../assets/icons/arrow-left.svg?component';
import { ReactComponent as ArrowRight } from '../assets/icons/arrow-right.svg?component';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "../styles/index.css";
import { getWeekDay } from "../util/date";
import Topbar from "../components/topbar";
import { Container } from "../components/container/style";
import { CustomFilterStyle } from "../components/filter/style";
import { useLocation, useParams } from "react-router-dom";
import NotFound from "./NotFound";
import { getCompany, getCompanyProperties, getCompanySchedules, registerCompanyScheduleView } from "../services/endpoints/company";
import { getServicesPublic } from "../services/endpoints/service";
import { formataNumeroTelefone, formatSchedulesToISO, transformarHorariosPorData } from "../util/format";
import { ThreeDots } from "react-loader-spinner";
import DateRangeSelector from "../components/dateRangeSelector";
import Dialog from "../components/dialog";
import { Title } from "../components/title";
import { Separator } from "../components/separator/style";
import { createReservedSchedule, removeReservedSchedule } from "../services/endpoints/reservedSchedule";
import { addToWaitingQueue } from "../services/endpoints/waitingQueue";
import { ToastContainer, toast } from "react-toastify";
import { isMobile, openWhatsApp } from "../util/util";
import { WhatsApp } from '@mui/icons-material';
import FilterDropdown from "../components/filterDropdown";
import { Button } from "../components/button";
import SimpleScheduleFlow from "./home/SimpleScheduleFlow";
import AccessChoiceDialog from "../components/customer/AccessChoiceDialog";
import { RescheduleBanner, RescheduleConfirm } from "../components/customer/Reschedule";
import { hasChosenGuest, useCustomer } from "../util/customerSession";
import { isAvailableLogin } from "../util/auth";
import {
  DateHeader,
  WaitlistButton,
  DialogInput,
  Label,
  DialogSelect
} from "../components/scheduleDialogs/style";

export default function Home() {
  const hasTrackedAgendaView = React.useRef(false);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <button><ArrowRight/></button>,
    prevArrow: <button><ArrowLeft/></button>
  };
  const [filter, setFilter] = React.useState({
    name: "3 dias",
    indexActive: 0,
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0],
  });
  const { companyUrl } = useParams();
  const location = useLocation();
  const { customer, loading: loadingCustomer } = useCustomer();
  // Remarcação vinda da área do cliente (só vale para a agenda da mesma empresa)
  const reschedule = location.state?.reschedule?.companyUrl === companyUrl ? location.state.reschedule : null;
  const [rescheduleTarget, setRescheduleTarget] = React.useState(null);
  const [accessChoiceClosed, setAccessChoiceClosed] = React.useState(false);
  const [mobile, setMobile] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [loadingSchedule, setLoadingSchedule] = React.useState(true);
  const [companyInfo, setCompanyInfo] = React.useState();
  const [companyNotFound, setCompanyNotFound] = React.useState(false);
  const [scheduleMode, setScheduleMode] = React.useState(null);
  const [horarios, setHorarios] = React.useState([]);
  const [filtered, setFiltered] = React.useState([]);
  const [services, setServices] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedSchedule, setSelectedSchedule] = React.useState(
    {
      data: "",
      horario: "",
      nome: undefined,
      telefone: undefined,
      servicoId: undefined,
      service: undefined
    }
  );
  const [available, setAvailable] = React.useState()
  const [code, setCode] = React.useState()
  const [error, setError] = React.useState()
  const [waitlistOpen, setWaitlistOpen] = React.useState(false);
  const [waitlistDate, setWaitlistDate] = React.useState('');
  const [waitlistData, setWaitlistData] = React.useState({ nome: '', telefone: '' });
  const [waitlistDone, setWaitlistDone] = React.useState(false);
  const filters = [
    { label: "Remover filtro", value: "", color: "" },
    { label: "Disponível", value: "available", color: "#4caf50" }
  ];

  const handleFilter = (name, index, startDate, endDate) => {
    switch (name) {
      case "3 dias":
        setFilter({
          name: name,
          indexActive: index,
          startDate: new Date().toISOString().split('T')[0],
          endDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0],
        });
        break;
      case "7 dias":
        setFilter({
          name: name,
          indexActive: index,
          startDate: new Date().toISOString().split('T')[0],
          endDate: new Date(new Date().setDate(new Date().getDate() + 6)).toISOString().split('T')[0],
        });
        break;
      default:
        if (!startDate || !endDate) {
          toast.error("É necessário selecionar uma data de início e uma data de fim para esse filtro.");
          return;
        }
        setFilter({
          name: name,
          indexActive: index,
          startDate: new Date(startDate).toISOString().split('T')[0],
          endDate: new Date(endDate).toISOString().split('T')[0],
        });
        break;
    }
  };
  
  const getCompanyInfo = async () => {
    setLoading(true);
    try {
      const response = await getCompany(companyUrl);
      setCompanyInfo(response.data);
      setLoading(false);
    } catch (error) {
      if (error?.response?.status === 404) {
        setCompanyNotFound(true);
      } else {
        toast.error("Erro ao buscar os dados da empresa.");
      }
      setLoading(false);
    }
  }

  const fetchScheduleMode = async () => {
    try {
      const response = await getCompanyProperties(companyUrl);
      setScheduleMode(response.data?.scheduleMode || "PADRAO");
    } catch (error) {
      setScheduleMode("PADRAO");
    }
  }

  const fetchServices = async () => {
    try {
      const response = await getServicesPublic(companyUrl);
      setServices(response.data || []);
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
      setServices([]);
    }
  }

  const handleCompanySchedules = async () => {
    setLoadingSchedule(true);
    try { 
      const response = await getCompanySchedules(companyUrl, filter.startDate, filter.endDate);
      setHorarios(transformarHorariosPorData(response.data));
      setLoadingSchedule(false);
    } catch (error) {
      toast.error("Erro ao buscar os horários da empresa:", error);
      setLoadingSchedule(false);
    }
  }

  const trackAgendaView = async () => {
    if (!companyUrl || hasTrackedAgendaView.current) {
      return;
    }

    try {
      await registerCompanyScheduleView(companyUrl);
      hasTrackedAgendaView.current = true;
    } catch (error) {
      console.error("Erro ao registrar visualizacao da agenda:", error);
    }
  }

  const selectSchedule = (data, horario, available, nome, service) => {
    if (reschedule) {
      if (available) setRescheduleTarget({ data, horario });
      return;
    }
    const selectedServiceId = service?.id || service?.servicoId || service?._id || "";
    setAvailable(available);
    // Cliente logado já chega com nome e WhatsApp preenchidos
    const prefill = available && customer
      ? { nome: customer.name, telefone: formataNumeroTelefone(customer.telephone || "") }
      : { nome };
    setSelectedSchedule({ data, horario, ...prefill, service, servicoId: selectedServiceId });
    setCode('');
    setOpen(true);
  }

  const makeSchedule = async () => {
    if(selectedSchedule.telefone.replace(/\D/g, '').length < 11){
      toast.error("Telefone inválido!");
      handleCompanySchedules(); 
      handleRestartProps();
      setOpen(false);
      return;
    }
    const scheduleISOFormat = formatSchedulesToISO({date: selectedSchedule.data, schedules: [selectedSchedule.horario]});
    const reservedSchedule = {
      name: selectedSchedule.nome,
      telephone: selectedSchedule.telefone.replace(/\D/g, ''),
      schedule: scheduleISOFormat[0],
      service: hasServices ? selectedSchedule.servicoId : null
    }
    try {
      const response = await createReservedSchedule(companyUrl, reservedSchedule);
      setCode(response.data);
    } catch (error) {
      handleCompanySchedules();
      toast.error("Erro ao criar agendamento:", error);
    }
  }

  const makeCancelSchedule = async () => {
    if(selectedSchedule.telefone.replace(/\D/g, '').length < 11 || code.length === 0){
      toast.error("Telefone/código de cancelamento devem ser preenchidos corretamente!");
      handleCompanySchedules(); 
      handleRestartProps();
      setOpen(false);
      return;
    }
    const scheduleISOFormat = formatSchedulesToISO({date: selectedSchedule.data, schedules: [selectedSchedule.horario]});
    const reservedSchedule = {
      telephone: selectedSchedule.telefone.replace(/\D/g, ''),
      schedule: scheduleISOFormat[0],
      cancelCode: code
    }
    try {
      await removeReservedSchedule(companyUrl, reservedSchedule);
      toast.success("Agendamento cancelado com sucesso!");
      handleCompanySchedules();
      handleRestartProps();
      setOpen(false);
    } catch (error) {
      setError(error.response.data);
    }
  }

  const handleRestartProps = () => {
    setSelectedSchedule(
      {
        data: "",
        horario: "",
        nome: "",
        telefone: "",
        servicoId: undefined,
        service: undefined
      }
    )
    setAvailable();
    setCode('')
    setError();
  }

  const itsAvailableNow = (date, time) => {
    const now = new Date().toLocaleString('sv-SE', 
      {
        timeZone: 'America/Sao_Paulo',
        hour12: false
      }
    ).replace(' ', 'T');

    const [day, month, year] = date.split("/");
    const [hour, minute] = time.split(":");

    const isoLike = `${year}-${month}-${day}T${hour}:${minute}:00`;
    return isoLike <= now;
  }

  const itsAvailableDayByArray = (value) => {
    const filtered = value.horarios.filter(iteminside =>
      iteminside.available === true &&
      !itsAvailableNow(value.data, iteminside.horario)
    );

    return filtered.length > 0;
  }

  const filterSchedulesByDropdown = (value) => {
    switch (value) {
      case "available": {
        const filtered = horarios
          .map(item => {
            const horariosFiltrados = item.horarios.filter(iteminside =>
              iteminside.available === true &&
              !itsAvailableNow(item.data, iteminside.horario)
            );

            return {
              ...item,
              horarios: horariosFiltrados
            };
          })
          .filter(item => item.horarios.length > 0);

        setFiltered(filtered);
        break;
      }
      default:
        setFiltered(horarios);
        break;
    }
  };
  
  const hasFutureSlots = (item) =>
    item.horarios.some(h => !itsAvailableNow(item.data, h.horario));

  const isFullyBooked = (item) =>
    hasFutureSlots(item) && !itsAvailableDayByArray(item);

  const openWaitlistDialog = (date) => {
    setWaitlistDate(date);
    setWaitlistData({ nome: '', telefone: '' });
    setWaitlistDone(false);
    setWaitlistOpen(true);
  };

  const submitWaitlist = async () => {
    if (waitlistData.telefone.replace(/\D/g, '').length < 11) {
      toast.error("Telefone inválido!");
      return;
    }
    const [d, m, y] = waitlistDate.split('/');
    const isoDate = `${y}-${m}-${d}`;
    try {
      await addToWaitingQueue(companyUrl, {
        name: waitlistData.nome,
        telephone: waitlistData.telefone.replace(/\D/g, ''),
        date: isoDate
      });
      setWaitlistDone(true);
    } catch {
      toast.error("Erro ao entrar na fila de espera. Tente novamente.");
    }
  };

  const hasAnyAvailableFutureSchedule = (horarios) => {

    return horarios.some(day =>
      day.horarios.some(h =>
        h.available === true &&
        !itsAvailableNow(day.data, h.horario)
      )
    );
  };

  useEffect(() => {
    if (scheduleMode === "SIMPLES") return;
    handleCompanySchedules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, scheduleMode]);

  useEffect(() => {
    getCompanyInfo();
    fetchServices();
    fetchScheduleMode();
    hasTrackedAgendaView.current = false;
    trackAgendaView();
    setMobile(isMobile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyUrl]);

  const hasServices = services.length > 0;
  const isScheduleFormInvalid = !selectedSchedule.nome || !selectedSchedule.telefone || (hasServices && !selectedSchedule.servicoId);

  // Link de empresa que não existe (ou rota digitada errado com um trecho só)
  if (companyNotFound) return <NotFound variant="company" />;

  return (
    <>
      {companyInfo && companyInfo.active === false && <BlockedAccessPage variant="public" />}
      {companyInfo && companyInfo.active !== false && scheduleMode === "SIMPLES" &&
        <SimpleScheduleFlow companyUrl={companyUrl} companyInfo={companyInfo} mobile={mobile} customer={customer} reschedule={reschedule} />
      }
      {companyInfo && companyInfo.active !== false && scheduleMode !== "SIMPLES" &&
        <div style={{ backgroundColor: 'var(--ui-page-bg)', minHeight: '100dvh', paddingBottom: '2rem', overflowX: 'hidden' }}>
          <Topbar
            name={companyInfo.name}
            imagem={companyInfo.imagem}
            whatsapp={companyInfo.whatsapp}
            instagram={companyInfo.instagram}
          />
          <CustomFilterStyle $width={mobile ? "calc(100% - 2rem)" : "80%"}>
            <FilterDropdown
              filters={filters}
              onChange={(value) => {
                filterSchedulesByDropdown(value);
              }}
            />
            <button className={filter.indexActive === 0 ? 'active filter-button' : 'filter-button'} onClick={() => handleFilter("3 dias", 0)}>
              3 dias
            </button>
            <button className={filter.indexActive === 1 ? 'active filter-button' : 'filter-button'} onClick={() => handleFilter("7 dias", 1)}>
              7 dias
            </button>
            <DateRangeSelector
              isActive={filter.indexActive === 2}
              onChangeRange={({ startDate, endDate }) => {
                handleFilter("personalizado", 2, startDate, endDate);
              }}
            />
          </CustomFilterStyle>
          {reschedule && <RescheduleBanner appointment={reschedule} width={mobile ? "calc(100% - 2rem)" : "80%"} />}
          <Container
            $width={mobile ? "calc(100% - 2rem)" : "80%"}
            $padding="0 0 1.5em 0"
            $backgroundcolor="#fff"
            $borderRadius="var(--ui-radius)"
            $border="1px solid var(--ui-border)"
            $boxshadow="var(--ui-card-shadow)"
          >
            <Slider {...settings}>
              {!loadingSchedule && horarios.length > 0 && filtered.length > 0 ? 
              filtered.map((item, index) => (
                hasFutureSlots(item) && (
                  <div key={index} className="slide">
                    <DateHeader>
                      <div>
                        <h3 style={{ margin: 0 }}>{item.data}</h3>
                        <span>{"("+getWeekDay(item.data)+")"}</span>
                      </div>
                      {isFullyBooked(item) && (
                        <WaitlistButton onClick={() => openWaitlistDialog(item.data)}>
                          Fila de espera
                        </WaitlistButton>
                      )}
                    </DateHeader>
                    <div className="horarios-container">
                      {item.horarios.map((iteminside, i) =>
                        !itsAvailableNow(item.data, iteminside.horario) ? (
                          <button
                            key={i}
                            className={
                              iteminside.available === false
                                ? 'horario-btn horario-btn-unavailable'
                                : 'horario-btn'
                            }
                            onClick={() =>
                              selectSchedule(
                                item.data,
                                iteminside.horario,
                                iteminside.available,
                                iteminside.name,
                                iteminside.service
                              )
                            }
                          >
                            {iteminside.horario}
                          </button>
                        ) : null
                      )}
                    </div>
                  </div>
                )
              )) : 
              horarios.map((item, index) => (
                hasFutureSlots(item) && (
                  <div key={index} className="slide">
                    <DateHeader>
                      <div>
                        <h3 style={{ margin: 0 }}>{item.data}</h3>
                        <span>{"("+getWeekDay(item.data)+")"}</span>
                      </div>
                      {isFullyBooked(item) && (
                        <WaitlistButton onClick={() => openWaitlistDialog(item.data)}>
                          Fila de espera
                        </WaitlistButton>
                      )}
                    </DateHeader>
                    <div className="horarios-container">
                      {item.horarios.map((iteminside, i) =>
                        !itsAvailableNow(item.data, iteminside.horario) ? (
                          <button
                            key={i}
                            className={
                              iteminside.available === false
                                ? 'horario-btn horario-btn-unavailable'
                                : 'horario-btn'
                            }
                            onClick={() =>
                              selectSchedule(
                                item.data,
                                iteminside.horario,
                                iteminside.available,
                                iteminside.name,
                                iteminside.service
                              )
                            }
                          >
                            {iteminside.horario}
                          </button>
                        ) : null
                      )}
                    </div>
                  </div>
                )
              ))
              }
              {!loadingSchedule && !hasAnyAvailableFutureSchedule(horarios) && (
                <div className="slide no-schedules">
                  <h3>Nenhum horário disponível</h3>
                  <p>Verifique novamente mais tarde.</p>
                </div>
              )}
              {loadingSchedule &&
                <div className="loading-slide">
                  <ThreeDots color="#1E2240" height={20} width={60} />
                  <p>Buscando horários...</p>
                </div>
              }
            </Slider>
          </Container>
        </div>
      }
      {/* PREENCHIMENTO DADOS DO AGENDAMENTO */}
      <Dialog open={open && available && !code} onClose={() => {setOpen(false); handleRestartProps()}}>
        <Title
          $fontweight="700"
          $fontsize="1.2rem"
        >
          Confirme seu agendamento
        </Title>
        <Separator 
          $width="100%"
          $bordercolor="var(--ui-border)"
          $margin="0.75rem 0 2rem 0"
          $style="dotted"
        />
        <form style={{ backgroundColor: "transparent", boxShadow: "none", width: "100%", padding: "0" }}>
          <Label>Data:</Label>
          <DialogInput value={selectedSchedule.data} readOnly />
          <Label>Horário:</Label>
          <DialogInput value={selectedSchedule.horario} readOnly />
          <Label>Digite seu nome:</Label>
          <DialogInput 
            type="text" 
            value={selectedSchedule.nome} 
            onChange={(e) => setSelectedSchedule({ ...selectedSchedule, nome: e.target.value })}
          />
          <Label>Digite seu telefone com DDD:</Label>
          <DialogInput 
            type="text" 
            value={formataNumeroTelefone(selectedSchedule.telefone || "")} 
            onChange={(e) => setSelectedSchedule({ ...selectedSchedule, telefone: formataNumeroTelefone(e.target.value) }) }
          />
          {hasServices && (
            <>
              <Label>Selecione um serviço:</Label>
              <DialogSelect
                value={selectedSchedule.servicoId || ""}
                onChange={(e) => setSelectedSchedule({ ...selectedSchedule, servicoId: e.target.value })}
              >
                <option key="default" value=""> Selecione um serviço </option>
                {services.map((service) => (
                  <option key={service.id} value={service.id}>
                    {service.name}
                  </option>
                ))}
              </DialogSelect>
            </>
          )}
          <Container
              $width="auto"
              $display="flex"
              $alignitems="flex-end"
              $justifycontent="space-between"
              $margin="0"
              $backgroundcolor="transparent"
              $boxshadow="none"
          >
            <Button
              variant="link"
              type="button"
              onClick={() => {setOpen(false); handleCompanySchedules(); handleRestartProps()}}
            >
                Voltar
            </Button>
            <Button
              type="button"
              variant={isScheduleFormInvalid ? "disabled" : "confirm"}
              onClick={makeSchedule}
            >
                Agendar
            </Button>
          </Container>
        </form>
      </Dialog>
      {/* CONFIRMAÇÃO AGENDAMENTO + CODIGO CANCELAMENTO */}
      <Dialog open={open && available && code} onClose={() => { setOpen(false); handleCompanySchedules(); handleRestartProps()}}>
        <Title
          $fontweight="700"
          $fontsize="1.2rem"
        >
          Agendamento confirmado!
        </Title>
        <Separator $width="100%" $bordercolor="#ccc" $margin="1rem 0 3rem 0" $style="dotted" />
        <form style={{ backgroundColor: "transparent", boxShadow: "none", width: "100%", padding: "0", textAlign: "center" }}>
          <span>Guarde o código abaixo para desmarcar:</span>
          <h3 style={{margin: '2rem 0'}}>{code}</h3>
          <span style={{fontSize: '12px', color: '#535353'}}>*recomendamos tirar print da tela</span>
          <Container
              $width="auto"
              $display="flex"
              $alignitems="center"
              $justifycontent="center"
              $margin="2rem 0 0 0"
              $backgroundcolor="transparent"
              $boxshadow="none"
          >
              <Button
                variant="confirm"
                type="button"
                onClick={() => { setOpen(false); handleCompanySchedules(); handleRestartProps()}}
            >
                OK
            </Button>
          </Container>
          <ToastContainer
            position={mobile ? "bottom-center" : "top-right"}
            autoClose={3000}
            closeButton={false}
            style={mobile ? { margin: '0 5% 1rem 5%', width: '90%' } : undefined}
          />
        </form>
      </Dialog>
      {/* PREENCHIMENTO DADOS CANCELAMENTO DO AGENDAMENTO */}
      <Dialog open={open && !available && !error} onClose={() => {setOpen(false); handleRestartProps()}}>
        <Title
          $fontweight="700"
          $fontsize="1.2rem"
        >
          Cancele seu agendamento
        </Title>
        <Separator $width="100%" $bordercolor="var(--ui-border)" $margin="1rem 0 3rem 0" $style="dotted" />
        <form style={{ backgroundColor: "transparent", boxShadow: "none", width: "100%", padding: "0" }}>
          <Label>Data:</Label>
          <DialogInput type="text" value={selectedSchedule.data} readOnly />
          <Label>Horário:</Label>
          <DialogInput type="text" value={selectedSchedule.horario} readOnly />
          <Label>Nome:</Label>
          <DialogInput 
            type="text" 
            value={selectedSchedule.nome} 
            onChange={(e) => setSelectedSchedule({ ...selectedSchedule, nome: e.target.value })}
            readOnly
          />
          <Label>Digite seu telefone com DDD:</Label>
          <DialogInput 
            type="text" 
            value={formataNumeroTelefone(selectedSchedule.telefone || "")} 
            onChange={(e) => setSelectedSchedule({ ...selectedSchedule, telefone: formataNumeroTelefone(e.target.value) }) }
          />
          {selectedSchedule.servicoId && (
            <>
              <Label>Serviço:</Label>
              <DialogSelect
                value={selectedSchedule.servicoId || ""}
                disabled
              >
                {selectedSchedule.service && !services.some((service) => String(service.id) === String(selectedSchedule.servicoId)) && (
                  <option key="selected-service" value={selectedSchedule.servicoId}>
                    {selectedSchedule.service.name}
                  </option>
                )}
                {services.map((service) => (
                  <option key={service.id} value={service.id}>
                    {service.name}
                  </option>
                ))}
              </DialogSelect>
            </>
          )}
          <Label>Digite seu código de cancelamento:</Label>
          <DialogInput 
            type="text" 
            value={code} 
            onChange={(e) => setCode(e.target.value)}
          />
          <Separator $width="100%" $bordercolor="#ccc" $style="dotted" />
          <Container
              $width="auto"
              $display="flex"
              $alignitems="flex-end"
              $justifycontent="space-between"
              $margin="0"
              $backgroundcolor="transparent"
              $boxshadow="none"
          >
            <Button
              variant="link"
              type="button"
              onClick={() => {setOpen(false); handleRestartProps()}}
            >
                Voltar
            </Button>
            <Button
              type="button"
              variant={!code || !selectedSchedule.telefone ? "disabled" : "confirm"}
              onClick={makeCancelSchedule}
            >
                Cancelar
            </Button>
          </Container>
          <ToastContainer
            position={mobile ? "bottom-center" : "top-right"}
            autoClose={3000}
            closeButton={false}
            style={mobile ? { margin: '0 5% 1rem 5%', width: '90%' } : undefined}
          />
        </form>
      </Dialog>
      {/* CANCELAMENTO NÃO POSSÍVEL */}
      {companyInfo && 
        <Dialog open={open && !available && error} onClose={() => {setOpen(false); handleRestartProps()}}>
          <Title
            $fontweight="700"
            $fontsize="1.2rem"
          >
            Não foi possível cancelar seu agendamento
          </Title>
          <Separator $width="100%" $bordercolor="#ccc" $margin="1rem 0 3rem 0" $style="dotted" />
          <form style={{ backgroundColor: "transparent", boxShadow: "none", width: "100%", padding: "0" }}>
            <span>
              {error}
            </span>
            <Container
                $width="auto"
                $display="flex"
                $alignitems="flex-end"
                $justifycontent="space-between"
                $margin="2rem 0 0 0"
                $backgroundcolor="transparent"
                $boxshadow="none"
            >
              <Button
                style={{ fontSize: "0.8rem", padding: "0.5rem 1rem", backgroundColor: "transparent", borderColor: "transparent", color: "#000000" }}
                onClick={() => {setOpen(false); handleRestartProps()}}
              >
                  Voltar
              </Button>
              <Button
                style={{ fontSize: "0.8rem", padding: "0.5rem 1rem", backgroundColor: "#00832D", borderColor: "#00832D", display: "flex", alignItems: "center", gap: ".25rem" }}
                onClick={() => openWhatsApp(companyInfo.whatsapp)}
              >
                <WhatsApp/> Falar com {companyInfo.name}
              </Button>
            </Container>
            <ToastContainer
              position={mobile ? "bottom-center" : "top-right"}
              autoClose={3000}
              closeButton={false}
              style={mobile ? { margin: '0 5% 1rem 5%', width: '90%' } : undefined}
            />
          </form>
        </Dialog>
      }
      {/* FILA DE ESPERA — FORMULÁRIO */}
      <Dialog open={waitlistOpen && !waitlistDone} onClose={() => setWaitlistOpen(false)}>
        <Title $fontweight="700" $fontsize="1.2rem">
          Entrar na fila de espera
        </Title>
        <Separator $width="100%" $bordercolor="var(--ui-border)" $margin="0.75rem 0 2rem 0" $style="dotted" />
        <form style={{ backgroundColor: "transparent", boxShadow: "none", width: "100%", padding: "0" }}>
          <Label>Data:</Label>
          <DialogInput value={waitlistDate} readOnly />
          <Label>Digite seu nome:</Label>
          <DialogInput
            type="text"
            value={waitlistData.nome}
            onChange={(e) => setWaitlistData({ ...waitlistData, nome: e.target.value })}
          />
          <Label>Digite seu telefone com DDD:</Label>
          <DialogInput
            type="text"
            value={formataNumeroTelefone(waitlistData.telefone || "")}
            onChange={(e) => setWaitlistData({ ...waitlistData, telefone: formataNumeroTelefone(e.target.value) })}
          />
          <Container
            $width="auto" $display="flex" $alignitems="flex-end" $justifycontent="space-between"
            $margin="0" $backgroundcolor="transparent" $boxshadow="none"
          >
            <Button variant="link" type="button" onClick={() => setWaitlistOpen(false)}>Voltar</Button>
            <Button
              type="button"
              variant={!waitlistData.nome || !waitlistData.telefone ? "disabled" : "confirm"}
              onClick={submitWaitlist}
            >
              Confirmar
            </Button>
          </Container>
        </form>
      </Dialog>
      {/* FILA DE ESPERA — CONFIRMAÇÃO */}
      <Dialog open={waitlistOpen && waitlistDone} onClose={() => setWaitlistOpen(false)}>
        <Title $fontweight="700" $fontsize="1.2rem">
          Você está na fila!
        </Title>
        <Separator $width="100%" $bordercolor="#ccc" $margin="1rem 0 3rem 0" $style="dotted" />
        <form style={{ backgroundColor: "transparent", boxShadow: "none", width: "100%", padding: "0", textAlign: "center" }}>
          <span>Te avisamos caso um horário abra no dia <strong>{waitlistDate}</strong>.</span>
          <Container
            $width="auto" $display="flex" $alignitems="center" $justifycontent="center"
            $margin="2rem 0 0 0" $backgroundcolor="transparent" $boxshadow="none"
          >
            <Button variant="confirm" type="button" onClick={() => setWaitlistOpen(false)}>OK</Button>
          </Container>
        </form>
      </Dialog>
      {/* LOADING */}
      {loading && companyInfo === undefined &&
        <Container 
          $width="100%" 
          $height="100vh" 
          $margin="0" 
          $padding="0" 
          $backgroundcolor="none"
          $borderRadius="0" 
          $border="none"
          $display="flex" 
          $justifycontent="center" 
          $alignitems="center"
          $boxshadow="none"
        >
          <span className="loader"></span>
        </Container>
      }

      {/* PRIMEIRO ACESSO: SEGUIR SEM CONTA OU ENTRAR */}
      <AccessChoiceDialog
        open={
          !!companyInfo && companyInfo.active !== false && !reschedule &&
          // Prestador logado (ex.: "Minha agenda" no app) vê a própria agenda sem a pergunta
          !loadingCustomer && !customer && !accessChoiceClosed && !hasChosenGuest() && !isAvailableLogin()
        }
        onClose={() => setAccessChoiceClosed(true)}
      />

      {/* REMARCAÇÃO (MODO PADRÃO) */}
      {reschedule && (
        <RescheduleConfirm
          appointment={reschedule}
          target={rescheduleTarget}
          onClose={() => { setRescheduleTarget(null); handleCompanySchedules(); }}
        />
      )}
    </>
  );
}

export { DateHeader, WaitlistButton, DialogInput, Label, DialogSelect };